import cx from 'clsx';
import * as React from 'react';

import * as styles from './HintQuestions.css';

interface IHintQuestionsProps {
  isRedesignedBlock?: boolean;
}

export const HintQuestions: React.FC<React.PropsWithChildren<IHintQuestionsProps>> = ({
  children,
  isRedesignedBlock,
}) => {
  return (
    <div className={cx(styles['hints-container'], isRedesignedBlock && styles['hints-container-redesigned'])}>
      {children}
    </div>
  );
};
